import React from "react";

export const Bhs = (props) => {
  return (
    <div id="bhs" className="text-center">

      <div className="container">
        <div className="section-title">
          <h2>Baggage Handling System (BHS) Integration with Baggage X-Ray for Airports</h2>
          <p>
            We specialize in the design, installation, and integration of Baggage Handling Systems (BHS) for airports. Our solutions seamlessly integrate conveyor-based baggage handling with Baggage X-Ray Screening Systems, enhancing operational efficiency, safety, and passenger experience.
            <br></br>
            Our BHS solutions are designed in compliance with international aviation security standards and can be customized to suit different airport sizes, passenger volumes, and operational requirements.
          </p>
        </div>
        <div className="row">
          <div className="bhs-text">
            <h2>Key Benefits of an Integrated BHS Solution</h2>
            <div className="list-style">
              <div className="col-lg-10 col-sm-12 col-xs-12  col-md-offset-1">
                <ul>
                  <ol><b>Improved Airport Operational Efficiency</b>
                    <li>Streamlines baggage processing and supports high passenger throughput with minimal delays.</li>
                  </ol>
                  <ol><b>Enhanced Security Compliance</b>
                    <li>Full integration with Baggage X-Ray systems ensures consistent and reliable security screening in line with international aviation standards.</li>
                  </ol>
                  <ol><b>Scalable and Future-Ready Design</b>
                    <li>The system is designed to allow future expansion and upgrades as airport capacity and requirements grow.</li>
                  </ol>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <img src="../img/bhs/01.jpg" alt="..." className="bhs-img" />
            <img src="../img/bhs/02.jpg" alt="..." className="bhs-img" />
          </div>
          <div className="col-md-12">
            <img src="../img/bhs/03.jpg" alt="..." className="bhs-img" />
          </div>
        </div>
      </div>

    </div>
  );
};
